import React from 'react';
import SettingsIco from '@icons/ovb/settings.svg';
import HelpIco from '@icons/common/help.svg';
import { Tooltip } from 'antd';
import { AUTO_INSIGHTS_HELP } from '@utils/help/links';
import {
  DrawerHeader, SettingsBtn, HelpLink, HelpLinkInToolTip, DrawerBody
} from './styled';

function Header({ openSettings }) {
  return (
    <DrawerHeader>
      <DrawerBody>
        Automatic Insights
        <Tooltip
          placement="bottom"
          title={() => {
            return <span>
              Automatic Insights helps you uncover baseline improvement opportunities.
              Use Settings icon on the top to fine-tune your insights.
              <HelpLinkInToolTip href={AUTO_INSIGHTS_HELP} target="_blank" rel="noopener noreferrer">
                Learn more
              </HelpLinkInToolTip>
            </span>
          }}
        >
          <HelpLink href={AUTO_INSIGHTS_HELP} target="_blank" rel="noopener noreferrer">
            <HelpIco style={{ marginLeft: '8px' }} />
          </HelpLink>
        </Tooltip>
      </DrawerBody>
      <SettingsBtn onClick={openSettings}>
        <SettingsIco />
      </SettingsBtn>
    </DrawerHeader>
  );
}

export default Header;
